// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bI-U","col":"styles_col__yLElx"};